import React from 'react';

import { Layout } from '@components/Layout';
import { QingdaoAlert } from '@components/utilities/Dashboard/QingdaoAlert';

export const TestQingdaoRouteAlert: React.FC = () => {
  return (
    <Layout title="TestQingdaoRouteAlert">
      <QingdaoAlert />
    </Layout>
  );
};
